import "./index.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Option = _interopRequireDefault(require("./Option"));

var _component = require("../_utils/component.js");

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('select'),
  components: {
    Popper: _Popover.default,
    Option: _Option.default
  },
  mixins: [_component.componentMixin],
  model: {
    prop: 'value',
    event: 'change'
  },

  provide() {
    return {
      select: this
    };
  },

  props: {
    // 下拉菜单触发方式
    trigger: {
      //  'click' / 'hover' / null
      type: String,
      default: 'click',
      validator: function validator(value) {
        return ['click', 'hover', null].indexOf(value) > -1;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },

    /**
     * 浮层位置
     */
    placement: {
      // 'top-start' 'top' 'top-end' 'left-start' 'left' 'left-end' 'bottom-start' 'bottom' 'bottom-end'
      type: String,
      default: 'bottom-start'
    },
    // 选项
    options: {
      // {value: string; label: string, key?: string}[]
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 占位符, value 没有值时展示
    placeholder: {
      type: String
    },
    // 当前值 可用配合 v-model 使用
    value: {
      type: [String, Number, Array],
      default: ''
    },
    // 偏移位置
    offset: {
      type: String,
      default: '0,6,0,0'
    },
    // 默认值
    defaultValue: {
      type: String,
      default: ''
    },
    // 下拉菜单浮层样式
    popoverStyle: {
      type: Object,

      default() {
        return {};
      }

    },
    // 下拉菜单浮层class
    popoverClass: {
      type: String
    },
    // 显示边框
    border: {
      type: Boolean,
      default: false
    }
  },

  data() {
    var value = '';

    if (this.$hasProp('value')) {
      value = this.value;
    } else if (this.$hasProp('defaultValue')) {
      value = this.defaultValue;
    }

    return {
      innerValue: value,
      visible: false,
      label: ''
    };
  },

  computed: {
    currentValue() {
      if (this.$hasProp('value')) {
        return this.value;
      }

      return this.value || this.innerValue;
    },

    currentLabel() {
      var _this = this;

      if (!this.currentValue) return '';
      var option = this.options.find(function (opt) {
        return opt.value === _this.currentValue;
      });
      return option ? option.label : '';
    }

  },
  methods: {
    setOption(value, label) {
      this.innerValue = value;
      this.label = label;
      this.visible = false; // 修改选项值触发

      this.$emit('change', value);
    },

    getPopperStyle() {
      if (this.$refs.select && this.visible) {
        this.lastWidth = this.$refs.select.$el.clientWidth + "px";
      }

      return (0, _assign.default)({
        width: this.lastWidth
      }, this.popoverStyle);
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("Popper", {
    ref: "select",
    class: _vm.bem({
      border: _vm.border,
      disabled: _vm.disabled
    }),
    attrs: {
      trigger: _vm.trigger,
      transitionName: "gd-fade",
      visible: _vm.visible && !_vm.disabled,
      tag: "span",
      lazy: _vm.lazy,
      appendToBody: _vm.appendToBody,
      arrow: false,
      placement: _vm.placement,
      modifiers: {
        offset: {
          offset: _vm.offset
        }
      }
    },
    on: {
      "update:visible": function updateVisible(v) {
        _vm.disabled ? null : _vm.visible = v;
      }
    }
  }, [_vm.currentLabel ? _c("em", {
    class: _vm.bem("label")
  }, [_vm._v(_vm._s(_vm.currentLabel))]) : _c("em", {
    class: _vm.bem("placeholder")
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), !_vm.disabled ? _c("i", {
    class: _vm.bem("arrow")
  }) : _vm._e(), _vm._v(" "), _c("ul", {
    ref: "popup",
    class: [_vm.bem("popover"), _vm.popoverClass],
    style: _vm.getPopperStyle(),
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, _vm._l(_vm.options, function (item) {
    return _c("li", {
      key: item.key || item.value || item.name
    }, [_c("Option", {
      attrs: {
        label: item.label,
        value: item.value
      }
    }, [_vm._t("default", null, {
      data: item,
      setOption: _vm.setOption
    })], 2)], 1);
  }), 0)]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default2 = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default2;